import { Box, IconButton, Button } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const WINDOW_SIZE = 5;

export default function PaginationControls({ page, totalPages, setPage }) {
    if (totalPages <= 1) return null;

    const windowStart = Math.max(
        1,
        Math.min(page - Math.floor(WINDOW_SIZE / 2), totalPages - WINDOW_SIZE + 1)
    );
    const windowEnd = Math.min(totalPages, windowStart + WINDOW_SIZE - 1);
    const pages = [];
    for (let p = windowStart; p <= windowEnd; p++) pages.push(p);

    return (
        <Box sx={{ mt: 3, display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
            <IconButton
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                size="small"
                aria-label="Previous page"
            >
                <ChevronLeftIcon />
            </IconButton>
            {pages.map((p) => (
                <Button
                    key={p}
                    variant={page === p ? "contained" : "outlined"}
                    onClick={() => setPage(p)}
                >
                    {p}
                </Button>
            ))}
            <IconButton
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
                size="small"
                aria-label="Next page"
            >
                <ChevronRightIcon />
            </IconButton>
        </Box>
    );
}
